import { createFileRoute } from "@tanstack/react-router";

import RequestPasswordResetPage from "~/pages/auth/RequestPasswordResetPage.tsx";

export const Route = createFileRoute("/reset-password")({
    component: RequestPasswordResetPage,
});
